// src/pages/admin/EventCreatePage.jsx

import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, doc, setDoc } from 'firebase/firestore';
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL
} from 'firebase/storage';
import { db } from '../../firebase';
import EventEditBinding from '../../components/events/edit/EventEditBinding';

export default function EventCreatePage() {
  const navigate = useNavigate();
  const eventsColl = collection(db, 'events');
  const newEventRef = useMemo(() => doc(eventsColl), [eventsColl]);
  const eventId = newEventRef.id;

  // ==============================
  // convertToWebp: PNG/JPEG 등 이미지를 WebP Blob으로 변환
  // ==============================
  const convertToWebp = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error('WebP 변환 실패'));
              }
            },
            'image/webp',
            1.0 // 품질: 0.0 ~ 1.0 (0.8 권장)
          );
        };
        img.onerror = () => reject(new Error('이미지 로딩 실패'));
        img.src = reader.result;
      };
      reader.onerror = () => reject(new Error('FileReader 실패'));
      reader.readAsDataURL(file);
    });
  };

  // ==============================
  // uploadFileWithCache: Blob/File 객체 업로드 + Cache-Control 설정
  // ==============================
  const uploadFileWithCache = async (blobOrFile, folderPath, filename, contentType) => {
    const storage = getStorage();
    const fileRef = storageRef(storage, `${folderPath}/${filename}`);
    const metadata = {
      contentType,
      cacheControl: 'public, max-age=43200' // 12시간 캐시
    };
    await uploadBytes(fileRef, blobOrFile, metadata);
    const url = await getDownloadURL(fileRef);
    return url;
  };

  const handleCreate = async ({ title, subtitle, startDate, endDate, content, heroFile }) => {
    let heroImagePath = '';

    if (heroFile) {
      // 이미지 파일인지 확인
      if (heroFile.type.startsWith('image/')) {
        // WebP로 변환 후 업로드
        const webpBlob = await convertToWebp(heroFile);
        const webpFilename = `${eventId}_hero`;
        heroImagePath = await uploadFileWithCache(
          webpBlob,
          `events/${eventId}`,
          webpFilename,
          'image/webp'
        );
      } else {
        // 이미지가 아니면 원본 그대로 업로드
        const filename = `${eventId}_hero`;
        heroImagePath = await uploadFileWithCache(
          heroFile,
          `events/${eventId}`,
          filename,
          heroFile.type
        );
      }
    }

    const payload = {
      id:       eventId,
      title,
      subtitle,
      startDate,
      endDate,
      content,
      ...(heroImagePath && { heroImagePath })
    };

    await setDoc(newEventRef, payload);
    alert('이벤트 등록 완료!');
    navigate('/admin', { state: { tab: 'events' } });
  };

  return (
    <EventEditBinding
      event={{}}            // 새로 만드는 화면이므로 빈 객체 전달
      onSubmit={handleCreate}
    />
  );
}
